import {FC, lazy, Suspense} from 'react'
import {Navigate} from 'react-router-dom'
import {AppLoading} from '../../../../_metronic/helpers/components/AppLoading'
import {useAuth} from '../../auth'
import {AuthModel} from '../../auth/core/_models'
import {staffPicksBusiness} from '../../auth/core/staffAccess'

const PublicInquiryPage = lazy(() => import('./PublicInquiryPage'))

/** Whether the panel's own inquiry page is theirs: a business, or staff granted «کسب‌وکارها». */
export const opensPanelInquiry = (user?: Pick<AuthModel, 'cpi' | 'staff'> & Partial<Pick<AuthModel, 'rl'>> | null) =>
  !!user && ((user.cpi ?? 0) > 0 || staffPicksBusiness(user))

/**
 * The public address «/companyInquery» (user request 1405/07/30): the panel's page with history for a business user, the
 * public page for anyone else, also for a visitor who signed in there with a mobile to buy the tax-file inquiry.
 */
export const CompanyInquiryEntry: FC = () => {
  const {currentUser} = useAuth()
  if (opensPanelInquiry(currentUser)) return <Navigate to='/extra-service/companyInquery' replace />
  return (
    <Suspense fallback={<AppLoading mode='page' message='در حال بارگذاری صفحه…' />}>
      <PublicInquiryPage />
    </Suspense>
  )
}

/** The personal tax-file inquiry's own address, «/tax-file-inquiry»: the same page for everyone, signed in or not. */
export const PersonalTaxFileInquiryEntry: FC = () => (
  <Suspense fallback={<AppLoading mode='page' message='در حال بارگذاری صفحه…' />}>
    <PublicInquiryPage focus='taxFile' />
  </Suspense>
)
